import { render } from "./ClientDetail.vue?vue&type=template&id=110cf84a"
import script from "./ClientDetail.vue?vue&type=script&lang=js"
export * from "./ClientDetail.vue?vue&type=script&lang=js"

import "./ClientDetail.vue?vue&type=style&index=0&id=110cf84a&lang=css"
script.render = render

export default script